module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "value": _vm.value,
      "position-absolutely": true,
      "position-x": _vm.positionX,
      "position-y": _vm.positionY,
      "nudge-top": 0,
      "content-class": "booking-menu-actions",
      "v-bind": _vm.$attrs
    },
    on: {
      "input": _vm.sendValue
    }
  }, [_c('v-list', _vm._l((_vm.menuList), function(item, indexItem) {
    return _c('v-list-tile', {
      key: indexItem,
      on: {
        "click": function($event) {
          _vm.makeAnAction(item)
        }
      }
    }, [_c('v-list-tile-action', [(item.icon) ? _c('v-icon', {
      class: [
        'icon-style',
        item.icon === 'cancel' ? 'red--text' : null
      ]
    }, [_vm._v(_vm._s(item.icon))]) : _c('img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fcd74c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/sub-component/MenuList.vue
// module id = 1596
// module chunks = 21